import api from './api';

const list = async (params = {}) => {
  const { data } = await api.get('/orders', { params });
  return data;
};

const get = async (id) => {
  const { data } = await api.get(`/orders/${id}`);
  return data;
};

const create = async (payload) => {
  const { data } = await api.post('/orders', payload);
  return data;
};

const update = async (id, payload) => {
  const { data } = await api.put(`/orders/${id}`, payload);
  return data;
};

const updateStatus = async (id, status) => {
  const { data } = await api.patch(`/orders/${id}/status`, { status });
  return data;
};

const orderService = { list, get, create, update, updateStatus };
export default orderService;
